<br>
  @if (customer) {
    <form id="customerForm" #customerForm="ngForm" class="container">
      <app-contact-info [customer]="customer"
        [canEdit]="canEdit"
        [canEditBilling]="true"
        (paymentInfoRequiredSet)="paymentInfoRequiredSet()"
        (customerPreSave)="customerPreSave($event)"
      ></app-contact-info>
      <!-- End of Non-Residential Customer Type Layout-->
      @if (customer.id && !isDialog && (isCustomer || canEdit)) {
        <app-customer-billing-profile [(customer)]="customer" (billingProfileEntryModalClosed)="billingProfileEntryModalClosed()"></app-customer-billing-profile>
      }
      <div>
        <h4>Customer Documents</h4>
        <app-blob-manager [angularUpload]="true" [parentRecordId]="customer.id" [containerName]="'customer'" [uploadLabel]="'Document'" [viewOnly]="!hasCustomerDocumentEditPermission"></app-blob-manager>
      </div>
      <div class="row">
        <div class="col-12">
          @if (customerForm.invalid && customerForm.submitted) {
            <div class="alert alert-danger" role="alert">
              There are errors on this page. Please correct the errors and resubmit.
            </div>
          }
        </div>
        @if (canEdit) {
          <div class="col-12" style="text-align: right;">
            @if (!isCustomer) {
              <p-button type="button" label="Delete" severity="danger"
              [disabled]="disableDelete" (click)="delete()"></p-button>
            }
            @if (!isCustomer) {
              <p-button type="button" severity="warn" label="Cancel"
              (click)="cancel()"></p-button>
            }
            <p-button type="submit" severity="success" label="Save"
            (click)="save(customerForm)" [disabled]="saving"></p-button>
          </div>
        }
      </div>
    </form>
  }

  @if (!canEdit && !isCustomer) {
    <div class="row">
      <div class="col-12 columnPadding">
        <p-button type="button" severity="danger" label="Return to all customers"
          (click)="cancel()">
        </p-button>
      </div>
    </div>
  }
<br>